import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import moment from 'moment-timezone'

import PopupTypes from '../../popup_types'
import { getTodayWithTimezone, onConfirm } from 'Shared/helpers'
import { SimRow, SimCell, SimDropdown, GlgTooltip } from 'SharedComponents'
import SwitchFilterSimGolf from './filters/switch_filter_sim_golf'
import { registrationDisplaysTime, isRegistrationOpenForMembership } from '../../column_helpers'

const getFutureMembershipProgramsNames = (membershipProgramsInfo, timezone) => {
  const today = getTodayWithTimezone(timezone)
  const mpNames = membershipProgramsInfo.filter(mp => moment(mp.startDate).isAfter(today)).map(mp => mp.name)

  return mpNames
}

const LeagueRowComponentSimGolf = (
  {
    id,
    name,
    product,
    startDate,
    registrationMessage,
    seasonId,
    seasonName,
    golfers,
    leagueURL,
    portalURL,
    categoryId,
    categoryStatus,
    categoryName,
    openRegistrationData,
    seasonsEnabled,
    showRegistration,
    deleteLeague,
    archiveLeague,
    restoreLeague,
    openPopup,
    golfHub,
    golfHubEnabled,
    toggleGolfHubPublished,
    timeZoneDisplay,
    ...props
  }) => {
  const [golfHubChecked, setGolfHubChecked ] = useState(golfHub === window.I18n.t('customer_center_comp.components.sim_golf_labels.published'))
  const [color, setColor] = useState('')
  const [registrationOpen, setRegistrationOpen] = useState()

  useEffect(() => {
    const currentCategory = props.categoryColor.filter(category =>
      categoryId && category.id === categoryId.toString()
    )
    setColor(currentCategory[0].color)
  }, [])

  let dropdownOptions
  dropdownOptions = []

  dropdownOptions.push({
    label: window.I18n.t('customer_center_comp.components.sim_golf_buttons.go_to_portal'),
    url: portalURL,
  })

  dropdownOptions.push({
    label: `${window.I18n.t('customer_center_comp.components.sim_golf_buttons.go_to')} ${ _.capitalize(product) }`,
    url: leagueURL,
    destination: product,
  })

  dropdownOptions.push({
    label: `${window.I18n.t('customer_center_comp.components.sim_golf_buttons.clone')} ${ _.capitalize(product) }`,
    onClick: () => openPopup(PopupTypes.CLONE_EVENT, {
      leagueId: id,
    }),
    image: require('clone_plus.svg'),
  })

  dropdownOptions.push({
    label: window.I18n.t('customer_center_comp.components.sim_golf_buttons.change_category'),
    onClick: () => openPopup(PopupTypes.CHANGE_CATEGORY, {
      categoryId: props.category,
      leagueName: name,
      leagueId: id,
    }),
    image: require('folder_open.svg'),
  })

  if (seasonsEnabled) {
    dropdownOptions.push({
      label: window.I18n.t('customer_center_comp.components.sim_golf_buttons.change_season'),
      onClick: () => openPopup(PopupTypes.CHANGE_SEASON, {
        leagueName: name,
        leagueId: id,
        seasonId,
      }),
      image: require('calendar_sim_golf.svg'),
    })
  }

  let selectedDropdownOption = {}
  if (openRegistrationData.hasOpenRegistration) {
    if (openRegistrationData.canInvitationsList || openRegistrationData.canUseMembershipPrograms) {
      selectedDropdownOption = {
        leagueId: id,
        openRegistrationStatus: openRegistrationData.openRegistrationStatus,
        canInvitationsList: openRegistrationData.canInvitationsList,
        canUseMembershipPrograms: openRegistrationData.canUseMembershipPrograms,
        futureMembershipProgramsNames: getFutureMembershipProgramsNames(openRegistrationData.membershipProgramsInfo, props.timeZone),
        registrationDatesURL: openRegistrationData.registrationDatesURL,
      }
    } else if (registrationOpen) {
      selectedDropdownOption = {
        leagueId: id,
        openRegistrationStatus: openRegistrationData.openRegistrationStatus,
        canInvitationsList: openRegistrationData.canInvitationsList,
        canUseMembershipPrograms: openRegistrationData.canUseMembershipPrograms,
        futureMembershipProgramsNames: getFutureMembershipProgramsNames(openRegistrationData.membershipProgramsInfo, props.timeZone),
        registrationDatesURL: openRegistrationData.registrationDatesURL,
      }
    } else { // registration is closed
      selectedDropdownOption = {
        leagueId: id,
        openRegistrationStatus: openRegistrationData.openRegistrationStatus,
        canInvitationsList: openRegistrationData.canInvitationsList,
        canUseMembershipPrograms: openRegistrationData.canUseMembershipPrograms,
        futureMembershipProgramsNames: getFutureMembershipProgramsNames(openRegistrationData.membershipProgramsInfo, props.timeZone),
        registrationDatesURL: openRegistrationData.registrationDatesURL,
      }
    }
  }

  let archiveOption
  if (categoryStatus === 'archived') {
    archiveOption = {
      label: window.I18n.t('customer_center_comp.components.sim_golf_buttons.restore'),
      onClick: () => restoreLeague(id),
      image: require('restore.svg'),
    }
  } else {
    archiveOption = {
      label: window.I18n.t('customer_center_comp.components.sim_golf_buttons.archive'),
      onClick: () => {
        onConfirm(`${window.I18n.t('customer_center_comp.components.popup_questions.want_to_archive')} ${ name }? ` +
          window.I18n.t('customer_center_comp.components.popup_questions.info_archive'), () => {
          archiveLeague(id)
        })
      },
      image: require('archive.svg'),
    }
  }

  dropdownOptions.push(archiveOption)

  dropdownOptions.push({
    label: window.I18n.t('customer_center_comp.components.sim_golf_buttons.delete'),
    onClick: () => {
      onConfirm(`${window.I18n.t('customer_center_comp.components.popup_questions.want_to_delete')} ${ name }? `, () => {
        deleteLeague(id)
      })
    },
    image: require('trash.svg'),
  })

  const formatDate = (startDate) => {
    if (startDate === '') {
      return ''
    }
    else {
      const date = new Date(startDate)
      return date.toLocaleString('en-US', { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric'}) || ''
    }
  }

  const membershipNames = _.join(openRegistrationData.membershipProgramsInfo.map(mp => mp.name), ', ')

  let registrationTitle =
    selectedDropdownOption.openRegistrationStatus === 'invitation_list' && selectedDropdownOption.canInvitationsList ?  window.I18n.t('customer_center_comp.components.sim_golf_labels.open_for_invitation_list') : 
    registrationDisplaysTime(registrationMessage) ? `${ registrationMessage } Date and time are displayed in ${ timeZoneDisplay } time` : 
    isRegistrationOpenForMembership(registrationMessage) ? membershipNames : ''

  let confirmedGolfers = Number(golfers[0]?.split(' ')[0])

  return (
    <SimRow { ...props } color={ color } id={ id }>
      <SimCell><a href={ leagueURL }>{ name }</a></SimCell>
      <SimCell>{ formatDate(startDate) }</SimCell>
      <SimCell>{ seasonName }</SimCell>
      <SimCell>
        { golfHub ?
          <SwitchFilterSimGolf
            switchFor='golfHub'
            isChecked={ golfHubChecked }
            toggleGolfHubPublished={ toggleGolfHubPublished }
            id={ id }
            setIsChecked={ setGolfHubChecked }
            golfHub={ golfHub }
            checkedSuffix={ window.I18n.t('customer_center_comp.components.sim_golf_labels.published') }
            uncheckedSuffix={ window.I18n.t('customer_center_comp.components.sim_golf_labels.unpublished') }
          /> :
          <a className='golf_hub_setup_link' href={`/leagues/${ id }/setup_golfhub_data`}>{ window.I18n.t('customer_center_comp.components.sim_golf_buttons.create') }</a>
        }
      </SimCell>
      <SimCell>
        {openRegistrationData.hasOpenRegistration ?
          <span className='registration_cell_container'>
            <SwitchFilterSimGolf
              switchFor='openRegistration'
              isChecked={ selectedDropdownOption.openRegistrationStatus === 'open' || registrationTitle != '' }
              setIsChecked={ setRegistrationOpen }
              openPopup={ openPopup }
              popupTypes={ PopupTypes.EXISTING_TIMES }
              selectedDropdownOption= { selectedDropdownOption }
              openRegistrationData={ openRegistrationData }
              checkedSuffix={ window.I18n.t('customer_center_comp.components.sim_golf_labels.open') }
              uncheckedSuffix={ window.I18n.t('customer_center_comp.components.sim_golf_labels.closed') }
            />
            { registrationTitle !== '' &&
              <GlgTooltip tooltip={ registrationTitle } placement='bottom'>
                <img src={ require('info_sim_golf.svg') } />
              </GlgTooltip>
            }
          </span> :
          <a className='registration_setup_link' href={`/leagues/${ id }/edit_registration_form?source=default_reg_settings`}>{ window.I18n.t('customer_center_comp.components.sim_golf_buttons.set_up') }</a>
        }
      </SimCell>
      <SimCell>{ confirmedGolfers || 0 }</SimCell>
      <SimCell className='actionCell'><SimDropdown items={ dropdownOptions } direction="left" /></SimCell>
    </SimRow>
  )
}

LeagueRowComponentSimGolf.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  product: PropTypes.string.isRequired,
  leagueURL: PropTypes.string.isRequired,
  openRegistrationData: PropTypes.object.isRequired,
  deleteLeague: PropTypes.func.isRequired,
  openPopup: PropTypes.func.isRequired,
  archiveLeague: PropTypes.func.isRequired,
  restoreLeague: PropTypes.func.isRequired,
  timeZone: PropTypes.string.isRequired,
  userIsCustomerManager: PropTypes.bool.isRequired,
  toggleGolfHubPublished: PropTypes.func,
  seasonsEnabled: PropTypes.bool,
  showRegistration: PropTypes.bool,
  portalURL: PropTypes.string,
  categoryId: PropTypes.string,
  categoryName: PropTypes.string,
  categoryStatus: PropTypes.string,
  startDate: PropTypes.string,
  registrationMessage: PropTypes.string,
  seasonId: PropTypes.string,
  seasonName: PropTypes.string,
  golfers: PropTypes.array,
  golfHub: PropTypes.string,
}

export default LeagueRowComponentSimGolf